const teams = {
  create_new: 'Create new',
  create_new_teamspace: 'Create new teamspace',
  admin: 'Admin',
  access_and_roles: 'Team access and roles',
  invite_users: 'Invite users',
  members: 'Team members',
  simulations_left: '{{count}} simulations left',
  appraisals_left: '{{count}} appraisals left',
  unlimited_simulations: 'Unlimited simulations',
  unlimited_appraisals: 'Unlimited appraisals',
  navigation: {
    usage: 'Usage',
    people: 'People',
    general: 'General',
    report_settings: 'Report settings',
  },
  upgrade_to_invite: {
    title: 'Upgrade needed',
    description: 'You need to upgrade your account to invite team members.',
  },
  invited: {
    name: 'Name',
    role: 'Role',
    status: 'Status',
    active: 'Active',
    pending: 'Pending',
    pending_invite: 'Pending invite',
    expired_invite: 'Expired',
    rejected: 'Rejected',
  },
  member_menu: {
    upgrade_to_admin: 'Upgrade to admin',
    remove_from_workspace: 'Remove from workspace',
    revoke_invitation: 'Revoke the invitation',
    resend_invitation: 'Resend the invitation',
    downgrade_to_member: 'Downgrade to member',
  },
  role: {
    member: 'Member',
    admin: 'Admin',
    owner: 'Owner',
  },
  menu: {
    people: 'People',
    general: 'General',
    usage: 'Usage',
    report_settings: 'Report settings',
    settings: 'Settings',
    billing: 'Billing',
    invoices: 'Invoices',
  },
  settings: {
    title: 'Settings',
    general: {
      title: 'General',
      description: 'Configure general settings for this team.',
    },
    report_config: {
      title: 'Report requirements',
      description:
        'Configure default requirements for reports at team and prototype level.',
      current_source: 'Team reports currently use: {{source}}',
      open_settings: 'Manage report requirements',
    },
  },
  report_settings: {
    title: 'Report settings',
    description:
      'Configure default requirements for reports at team and prototype level.',
    open_settings: 'Open report settings',
    no_workspace: 'No workspace is linked to this team yet.',
    team_level: {
      title: 'Team level',
      description:
        'Default requirements applied to all reports in this team when no more specific settings exist.',
      editing_description:
        'Changes apply to all reports in this team unless overridden at prototype level.',
    },
    prototype_level: {
      figma_title: 'Figma prototype level',
      figma_description:
        'Default requirements for all Figma reports in this team.',
      vibe_title: 'Website level',
      vibe_description:
        'Default requirements for all Vibe reports in this team.',
      editing_description:
        'Changes apply to all reports of this type unless a single report has custom settings.',
    },
  },
  people: {
    title: 'People',
  },
  billing: {
    title: 'Billing',
  },
  invoices: {
    title: 'Invoices',
  },
  general: {
    title: 'General',
  },
  badge: {
    FREE: 'Free',
    PRO: 'Team',
    REGULAR: 'Solo',
    ENTERPRISE: 'Org',
  },
  usage: {
    title: 'Usage',
    simulations: {
      title: 'Simulations',
      summary: 'Usage summary',
      total: 'Total',
      used: 'Used',
      remaining: 'Remaining',
      progress: 'Usage progress',
      buy: 'Buy simulations',
      buy_pack: 'Buy',
      n_for_m: '{{amount}} for {{price}}',
      member_usage: 'Team Member Usage',
      n_sims_one: '{{count}} sim',
      n_sims_other: '{{count}} sims',
    },
  },
  org_usage: {
    title: 'Organization usage',
    simulations: {
      title: 'Simulations',
      summary: 'Usage summary',
      total: 'Total',
      used: 'Used',
      remaining: 'Remaining',
      progress: 'Usage progress',
      buy: 'Buy simulations',
      team_usage: 'Team Usage',
      n_sims_one: '{{count}} sim',
      n_sims_other: '{{count}} sims',
    },
  },
  new_team: {
    name: 'Team name',
    name_placeholder: 'An Extraordinary Company',
    add_member: 'Add more',
    member_email: 'Email',
    member_email_placeholder: 'john.doe@email.com',
    member: 'Member',
    admin: 'Admin',
    unable_to_create: 'Unable to create new team',
  },
  update_team: {
    name: 'Team name',
    name_placeholder: 'An Extraordinary Company',
    unable_to_save: 'Unable to save changes',
  },
  validation: {
    member_email_invalid: 'Invalid email address',
    member_email_required: 'You need to provide email address',
    member_role_required: 'You need to select role',
    name_cannot_be_empty: 'Team name is required',
    name_too_short: 'Team name must have at least {{minLength}} characters',
    name_too_long: 'Team name must be no longer than {{maxLength}} characters',
  },
  remove_member: {
    title: 'Remove team member?',
    text: 'Are you sure you want to remove <tag>{{name}}</tag> from the team? They will immediately lose access to all team resources.',
    confirm: 'Remove user',
  },
  revoke_invitation: {
    title: 'Revoke the invitation?',
    text: 'Are you sure you want to revoke the invitation for <tag>{{name}}</tag>?',
    confirm: 'Revoke invitation',
  },
  invitation: {
    accept: 'Accept',
    reject: 'Reject',
    expired: 'This invitation has expired.',
    already_used: 'This invitation has been already used.',
    invalid_token: 'This invitation is incorrect.',
    user_not_found: 'Invited user was not found.',
    must_register_first: 'Invited user must create an account first.',
    incorrect: 'Invitation is incorrect or was already used.',
    other_error: 'An error occured trying to load invitation.',
    accepted: {
      title: 'Invitation accepted',
      text: "You've successfully joined the team.",
    },
    go_to_report_dashboard: 'Go to Report dashboard',
  },
  upgrade_card: {
    text: 'Upgrade to unlock more simulations, advanced insights, and team features',
    cta: 'View upgrade plans',
  },
  team_notification: {
    title: 'Switch to paid, shared area',
    start_up: {
      single_paid_team:
        'Only {{name}} has paid credits to test Flows. Teams are in the drop down or just click below.',
      multiple_paid_team:
        'There are teams with paid credits to test Flows. You can select one in the drop down.',
      select_team: 'Switch to {{name}}',
    },
    test_a_flow: {
      single_paid_team:
        'Only {{name}} has paid credits to test Flows. Teams are in the drop down or just click below.',
      multiple_paid_team:
        'There are teams with paid credits to test Flows. You can select one in the drop down.',
      select_team: 'Test a flow in {{name}}',
    },
  },
} as const;

export default teams;
